"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInformation = exports.getStandardError = exports.estimateTheta = void 0;
const utilities_1 = require("./utilities");
const differentialEvolution_1 = require("./differentialEvolution");
/**
 * @typedef {import('./types').OptionalNumber} OptionalNumber
 */
/**
 * @typedef {import('./types').QuestionConfig} QuestionConfig
 */
/**
 * @typedef {import('./types').IRTConfig} IRTConfig
 */
/**
 * @typedef {import('./types').IRTParams} IRTParams
 */
/**
 * @typedef {import('./types').Response} Response
 */
/**
 * Estimate Theta takes the config, the responses and returns the theta
 * @param {IRTParams} params
 * @param {Response[]} responses
 * @returns {number}
 */
function estimateTheta(params, responses) {
    const validResponses = responses.filter(({ questionId, answer }) => {
        return params[questionId] && params[questionId][answer.value];
    });
    if (validResponses.length === 0) {
        return 0;
    }
    const res = (0, differentialEvolution_1.differentialEvolution)(utilities_1.negativeLogLikelihood, [-5, 5], 50, 0.1, 0.3, 1000, validResponses, params);
    // Check that res is a number, or throw an error
    // if (!Number.isFinite(res)) {
    //   // console.log(params);
    //   throw new Error(`Theta is not a number, received ${res}`);
    // }
    return res;
}
exports.estimateTheta = estimateTheta;
/**
 *
 * @param {IRTParams} params
 * @param {Response[]} responses
 * @param {number} theta
 * @returns {number}
 */
function getStandardError(params, responses, theta) {
    let information = 0;
    responses.forEach((response) => {
        const questionParams = params[response.questionId];
        if (questionParams) {
            information += (0, utilities_1.informationResponseFunctionForQuestion)(Number.isFinite(theta) ? theta : 0, questionParams);
        }
    });
    let result;
    if (information === 0) {
        result = 99999.9;
    }
    else {
        result = 1 / Math.sqrt(information);
    }
    return result;
}
exports.getStandardError = getStandardError;
/**
 * Returns the information for a given question
 * @param {IRTParams} params
 * @param {number} theta
 * @param {string} questionId
 * @returns {number}
 */
function getInformation(params, theta, questionId) {
    const questionParams = params[questionId];
    if (!questionParams) {
        return 0;
    }
    const information = (0, utilities_1.informationResponseFunctionForQuestion)(Number.isFinite(theta) ? theta : 0, questionParams);
    return information;
}
exports.getInformation = getInformation;
//# sourceMappingURL=irtMethods.js.map